import { useState } from "react";

const inputStyle = {
  width: "100%", padding: "8px 12px", border: "1px solid #e0e0e0",
  borderRadius: "8px", fontSize: "0.92rem", color: "#212121",
  background: "#fff", outline: "none", boxSizing: "border-box",
};

const labelStyle = {
  fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase",
  letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block",
};

const FieldRow = ({ label, children }) => (
  <div style={{ marginBottom: "14px" }}>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);

const BillingHeaderRight = ({ formik, extendedView }) => {
  const [openSubscription, setOpenSubscription] = useState(formik.values.aborechnung);

  return (
    <div>
      <FieldRow label="Billing Date">
        <input type="date" name="datum" value={formik.values.datum}
          onChange={formik.handleChange} style={inputStyle} />
      </FieldRow>

      {extendedView && (
        <div style={{
          marginTop: "12px", padding: "14px 16px",
          background: "#f4f7ff", borderRadius: "10px",
          border: "1px solid #dde6ff",
        }}>
          <FieldRow label="Follow Up">
            <input type="date" name="wiedervorlage_datum" value={formik.values.wiedervorlage_datum}
              onChange={formik.handleChange} style={{ ...inputStyle, background: "#fff" }} />
          </FieldRow>

          {/* Subscription toggle */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "10px 14px", background: "#eaf0ff", borderRadius: "8px", marginBottom: "14px",
          }}>
            <span style={{ fontSize: "0.88rem", fontWeight: 600, color: "#424242" }}>Subscription</span>
            <label style={{ position: "relative", display: "inline-block", width: "40px", height: "22px", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={formik.values.aborechnung}
                onChange={() => {
                  formik.setFieldValue("aborechnung", !openSubscription);
                  setOpenSubscription(!openSubscription);
                }}
                style={{ opacity: 0, width: 0, height: 0 }}
              />
              <span style={{
                position: "absolute", inset: 0, borderRadius: "22px",
                background: openSubscription ? "#1a73e8" : "#e0e0e0",
                transition: "background 0.2s",
              }} />
              <span style={{
                position: "absolute", top: "3px",
                left: openSubscription ? "21px" : "3px",
                width: "16px", height: "16px", borderRadius: "50%",
                background: "#fff", transition: "left 0.2s",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
              }} />
            </label>
          </div>

          {openSubscription && (
            <div style={{
              background: "#eaf0ff", borderRadius: "10px", padding: "14px 16px",
              display: "flex", flexDirection: "column", gap: "12px",
            }}>
              <FieldRow label="Start">
                <input type="date" name="start" value={formik.values.start}
                  onChange={formik.handleChange} style={{ ...inputStyle, background: "#fff" }} />
              </FieldRow>
              <FieldRow label="End">
                <input type="date" name="ende" value={formik.values.ende}
                  onChange={formik.handleChange} style={{ ...inputStyle, background: "#fff" }} />
              </FieldRow>
              <FieldRow label="Payment Interval">
                <input type="text" name="rechnungsinterval" value={formik.values.rechnungsinterval}
                  onChange={formik.handleChange} style={{ ...inputStyle, maxWidth: "120px", background: "#fff" }} />
              </FieldRow>
              <FieldRow label="Sending Interval">
                <input type="text" name="versandinterval" value={formik.values.versandinterval}
                  onChange={formik.handleChange} style={{ ...inputStyle, maxWidth: "120px", background: "#fff" }} />
              </FieldRow>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BillingHeaderRight;
